module.exports = __webpack_public_path__ + "img/careDokter.6da53cb0.png";